import React from "react";
import { Container, Row, Col } from 'react-bootstrap';

const Advantage = ({
  title = "Join millions of innovative businesses worldwide and experience the Peerbits advantage.",
  sectionClass = ''
}) => {


  return (
    <section className={`section ${sectionClass}`}>
      <Container>
        <Row className="align-items-center g-5" xs={1} lg={2}>
          <Col>
            <h2 className="h3 mb-0" dangerouslySetInnerHTML={{ __html: title }} />
          </Col>
          <Col>
            <Row className="align-items-center" xs={2}>
              <Col>
                {/* <div className="clutch-widget" data-url="https://widget.clutch.co" data-widget-type="14" data-height="50" data-nofollow="true" data-expandifr="true" data-scale="100" data-clutchcompany-id="25335"></div> */}
                <div
                  className="clutch-widget"
                  data-url="https://widget.clutch.co"
                  data-widget-type="14"
                  data-height="50"
                  data-nofollow="true"
                  data-expandifr="true"
                  data-scale="100"
                  data-clutchcompany-id="25335"
                >
                  <iframe
                    id="iframe-0.1466292729386529"
                    width="100%"
                    src="https://widget.clutch.co/widgets/get/14?ref_domain=www.peerbits.com&uid=25335&rel_nofollow=true&ref_path=/hire-python-developers.html"
                    height="50px"
                    scrolling="no"
                    style={{ border: 'none', overflow: 'hidden', display: 'block' }}
                    title="Peerbits Clutch Review Widget 14"
                  />
                </div>
              </Col>
              <Col>
                {/* <div className="goodfirm-widget" data-widget-type="goodfirms-widget-t1" data-height="198" data-company-id="56"></div> */}
                <div
                  className="goodfirm-widget"
                  data-widget-type="goodfirms-widget-t1"
                  data-height="198"
                  data-company-id="56"
                >
                  <iframe
                    title="GoodFirms Widget"
                    id="iframe-0.8055232331969437"
                    frameBorder="0"
                    width="100%"
                    height="198px"
                    scrolling="no"
                    src="https://widget.goodfirms.co?cid=56&wt=goodfirms-widget-t1"
                    style={{ display: 'block' }}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Advantage;